import { render, staticRenderFns } from "./MicrosoftExcel.vue?vue&type=template&id=39139882&scoped=true"
import script from "./MicrosoftExcel.vue?vue&type=script&lang=js"
export * from "./MicrosoftExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39139882",
  null
  
)

export default component.exports